<era-apple-device-ui [appleDevice]="appleDevice$ | async"
                     (applicationLockChange)="applicationLockChanged($event)"></era-apple-device-ui>